/* global axios */
import ApiClient from './ApiClient';

class ListsAPI extends ApiClient {
  constructor() {
    super('lists', { accountScoped: true });
  }

  get(page = 1, params = {}) {
    return axios.get(this.url, { params: { page, ...params } });
  }

  create(list) {
    return axios.post(this.url, { list });
  }

  update(id, list) {
    return axios.patch(`${this.url}/${id}`, { list });
  }

  duplicate(id, name) {
    return axios.post(`${this.url}/${id}/duplicate`, name ? { name } : {});
  }

  getMembers(listId, page = 1, params = {}) {
    return axios.get(`${this.url}/${listId}/members`, {
      params: { page, ...params },
    });
  }

  addMember(listId, contactId) {
    return axios.post(`${this.url}/${listId}/members`, {
      contact_id: contactId,
    });
  }

  delete(id, { deleteContacts = false } = {}) {
    return axios.delete(`${this.url}/${id}`, {
      params: deleteContacts ? { delete_contacts: 'true' } : {},
    });
  }

  removeMember(listId, listMemberId) {
    return axios.delete(`${this.url}/${listId}/members/${listMemberId}`);
  }

  exportList(listId, exportFormat = 'csv') {
    return axios.get(`${this.url}/${listId}/export`, {
      params: { export_format: exportFormat },
      responseType: 'blob',
    });
  }

  importContacts(listIds, file, mapping) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mapping', JSON.stringify(mapping));
    listIds.forEach(id => formData.append('list_ids[]', id));
    return axios.post(`${this.url}/import`, formData);
  }

  importStatus(id) {
    return axios.get(`${this.url}/import_status`, { params: { id } });
  }
}

export default new ListsAPI();
